/* Dealeasy owns discount rules. Cards read its current tiers, never apply discounts. */
(() => {
  function purchaseCards(root) {
    const picker = root.querySelector('.product-detail__variant-picker');
    picker?.querySelectorAll('fieldset').forEach(field => {
      if (field.querySelector('.bf-format-toggle')) return;
      const radios = field.querySelectorAll(':scope > input[type="radio"]');
      if (radios.length !== 2) return;
      const track = document.createElement('div');
      track.className = 'bf-format-toggle';
      const options = [...field.children].filter(el => el.matches('input[type="radio"],label'));
      field.append(track);
      options.forEach(el => track.append(el));
    });
    if (root.querySelector('[data-bf-pack-selector]')) { root.querySelector('.bf-volume-options')?.remove(); root.classList.remove('bf-purchase-compact'); return; }
    const buy = root.querySelector('.product-detail__buy-buttons');
    const quantity = buy?.querySelector('input[name="quantity"]');
    const source = picker?.querySelector('script[type="application/json"]');
    const app = root.querySelector('.lb-vd-container');
    const singlePresentation = !!root.querySelector('[data-bf-single-card]');
    if (!buy || !quantity || !source || (!app && !singlePresentation)) return;
    let variants;
    try { variants = JSON.parse(source.textContent); } catch { return; }
    const id = buy.querySelector('input[name="id"]')?.value;
    const variant = variants.find(v => String(v.id) === id);
    if (!variant || !Number.isFinite(variant.price)) return;
    const capsules = /c[aá]psul/i.test(variant.title);
    const tiers = [{ qty: 1, percent: 0 }];
    app?.querySelectorAll('.lb-vd-table-body-row').forEach(row => {
      const cells = row.querySelectorAll('td');
      const qty = Number(cells[0]?.textContent.match(/\d+/)?.[0]);
      const percent = Number(cells[1]?.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/)?.[1]?.replace(',', '.'));
      if (Number.isInteger(qty) && qty > 1 && percent > 0 && percent < 100 && !tiers.some(t => t.qty === qty)) tiers.push({ qty, percent });
    });
    if (capsules && tiers.length < 2 && !singlePresentation) { root.querySelector('.bf-volume-options')?.remove(); app.classList.remove('bf-tiers-enhanced'); root.classList.remove('bf-purchase-compact'); return; }
    if (singlePresentation && capsules && !tiers.some(t => t.qty === 3)) tiers.push({ qty: 3, percent: 0 });
    tiers.sort((a,b) => a.qty - b.qty);
    const shownTiers = capsules ? tiers.filter(t => t.qty === 1 || t.qty === 3) : tiers.filter(t => t.qty === 1);
    let panel = root.querySelector('.bf-volume-options');
    const key = JSON.stringify([variant.id, variant.price, variant.available, variant.quantity_rule, tiers]);
    if (!panel) {
      panel = document.createElement('fieldset');
      panel.className = 'bf-volume-options';
      buy.before(panel);
      panel.addEventListener('change', event => {
        if (!event.target.matches('.bf-volume-radio')) return;
        const input = root.querySelector('.product-detail__buy-buttons input[name="quantity"]');
        if (!input) return;
        input.value = event.target.value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (panel.dataset.key !== key) {
      if (panel.dataset.variant !== String(variant.id)) {
        quantity.value = '1';
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        panel.dataset.variant = String(variant.id);
      }
      panel.dataset.key = key;
      const money = cents => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2 }).format(cents / 100);
      const min = variant.quantity_rule?.min || 1;
      const max = variant.quantity_rule?.max;
      const increment = variant.quantity_rule?.increment || 1;
      panel.innerHTML = `<legend>${capsules ? 'Elige tu duración' : 'Tu presentación'}</legend>` + shownTiers.map(t => {
        const original = variant.price * t.qty;
        const total = original - Math.round(original * t.percent / 100);
        const disabled = !variant.available || t.qty < min || (max && t.qty > max) || (t.qty - min) % increment !== 0;
        const title = capsules ? `${t.qty * 30} días` : (singlePresentation ? '1 frasco' : '1 bolsa');
        const detail = capsules ? `${t.qty} ${t.qty === 1 ? 'frasco' : 'frascos'} · ${t.qty * 60} cápsulas` : 'Polvo · 100 g';
        return `<label class="bf-volume-card"><input class="bf-volume-radio" type="radio" name="bf-volume-${root.id}" value="${t.qty}" ${disabled ? 'disabled' : ''}><span class="bf-volume-copy"><strong>${title}</strong><small>${detail}</small>${t.percent ? `<small>Ahorras ${money(original - total)}</small>` : ''}</span><span class="bf-volume-price">${t.percent ? `<span class="bf-volume-badge">Ahorra ${t.percent}%</span>` : ''}<strong>${money(total)}</strong>${t.percent ? `<del>${money(original)}</del>` : ''}</span></label>`;
      }).join('') + `<p class="bf-volume-note">Compra única · Sin suscripción · MXN${capsules ? '<br>Duración calculada con 2 cápsulas al día, según etiqueta.' : ''}</p>`;
    }
    panel.querySelectorAll('.bf-volume-radio').forEach(input => { input.checked = Number(input.value) === Number(quantity.value); });
    app?.classList.add('bf-tiers-enhanced');
    root.classList.add('bf-purchase-compact');
  }
  function enhance(root) {
    root.querySelectorAll('.lb-vd-container').forEach(container => {
      container.setAttribute('aria-label', 'Descuentos por cantidad');
      const heading = container.querySelector('.lb-vd-promotion-text');
      // Only replace the known Spanish promotion; preserve different future offers.
      if (heading && heading.textContent.trim() === 'Obtén descuentos al comprar más productos de cualquier tipo') {
        heading.textContent = 'Más productos, más ahorro.';
        if (!container.querySelector('.bf-discount-subtitle')) {
          const subtitle = document.createElement('p');
          subtitle.className = 'bf-discount-subtitle';
          subtitle.textContent = 'Puedes combinar distintos productos. El descuento se aplica automáticamente en el carrito.';
          heading.insertAdjacentElement('afterend', subtitle);
        }
      }
      container.querySelectorAll('.lb-vd-table-body-row').forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length !== 2) return;
        const quantity = cells[0].textContent.trim().match(/^Compra\s+(\d+(?:\s*-\s*\d+|\+)?)$/i);
        if (quantity) cells[0].textContent = `${quantity[1]} productos`;
        const discount = cells[1].textContent.trim().match(/^Obtén\s+(\d+(?:[.,]\d+)?)%\s+off$/i);
        if (discount) {
          cells[1].textContent = `${discount[1]}%`;
          cells[1].setAttribute('aria-label', `${discount[1]}% de descuento`);
          cells[1].classList.add('bf-discount-value');
        }
      });
    });
    purchaseCards(root);
  }
  function init() {
    document.querySelectorAll('.bf-pdp').forEach(root => {
      if (root.dataset.bfDiscountObserved) return;
      root.dataset.bfDiscountObserved = 'true';
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; enhance(root); });
      });
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      root.addEventListener('change', () => requestAnimationFrame(() => enhance(root)));
      enhance(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
